import { Reducer } from 'redux'
import {
  User,
  KycDetails,
  FilterOptions,
  FilterValues,
  ActionTypes,
  MERCHANT_USERS_ACTIONS,
} from './types'

const initialState = {
  filterOptions: {
    userStatuses: [
      { value: 'verified', label: 'Verified' },
      { value: 'not verified', label: 'Not Verified' },
      { value: 'rejected', label: 'Rejected' },
    ],
  },
  filterValues: {
    currentPage: 1,
    searchString: '',

    userStatuses: [],
  },
  isUserTableLoading: false,
  users: [],
  totalCount: 0,
  pageLimit: 10,
  currentUserId: -1,

  isKycModalOpen: false,
  isKycLoading: false,
  kycDetails: {
    nik: '',
    phoneNumber: '',
    fullName: '',
    accountNumber: '',
    joinDate: '',
    kycStatus: '',
    kycRejectedReason: [],
    gender: '',
    placeOfBirth: '',
    dateOfBirth: '',
    nationality: '',
    motherMaidenName: '',
    religion: '',
    maritalStatus: '',
    address1: '',
    address2: '',
    village: '',
    district: '',
    city: '',
    province: '',
    country: '',
    idFrontUrl: '',
    selfieUrl: '',
  },
}

type State = {
  filterOptions: null | FilterOptions
  filterValues: FilterValues
  isUserTableLoading: boolean
  users: User[]
  totalCount: number
  pageLimit: number
  currentUserId: number

  isKycModalOpen: boolean
  isKycLoading: boolean
  kycDetails: KycDetails
}

export const merchantUsers: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case MERCHANT_USERS_ACTIONS.SET_SUB_USERS: {
      return {
        ...state,
        users: action.users,
        totalCount: action.totalCount,
      }
    }

    case MERCHANT_USERS_ACTIONS.SET_FILTERS: {
      return {
        ...state,
        filterValues: {
          ...state.filterValues,
          [action.filterKey]: action.filterValues,
        },
      }
    }

    case MERCHANT_USERS_ACTIONS.RESET_CURRENT_PAGE: {
      return {
        ...state,
        filterValues: {
          ...state.filterValues,
          currentPage: 1,
        },
      }
    }

    case MERCHANT_USERS_ACTIONS.SET_IS_USER_TABLE_LOADING: {
      return {
        ...state,
        isUserTableLoading: action.isLoading,
      }
    }

    case MERCHANT_USERS_ACTIONS.SET_KYC_MODAL_OPEN: {
      return {
        ...state,
        isKycModalOpen: action.isOpen,
        isKycLoading: action.isKycLoading,
        currentUserId: action.currentUserId,
      }
    }

    case MERCHANT_USERS_ACTIONS.SET_KYC_MODAL_CLOSED: {
      return {
        ...state,
        isKycModalOpen: action.isOpen,
      }
    }

    case MERCHANT_USERS_ACTIONS.SET_KYC_DETAILS: {
      return {
        ...state,
        isKycLoading: action.isKycLoading,
        kycDetails: action.kycDetails,
      }
    }

    default:
      return state
  }
}
